import { ArrowSquareOut, Books, Clock } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { SHOW_DONT_TELL, TPT_SHOW_DONT_TELL_URL } from "@/data/storeLinks";

const AmazonButton = ({ item }) => {
  if (item.amazon && !item.amazonComingSoon) {
    return (
      <a href={item.amazon} target="_blank" rel="noopener noreferrer" data-testid={`sdt-amazon-${item.id}`} className="flex-1">
        <Button variant="outline" className="w-full bg-amber-100 text-[#17284b] font-nunito font-bold border border-[#d4dff0] rounded-xl">
          <Books size={16} weight="bold" className="mr-1.5" /> Amazon Paperback
        </Button>
      </a>
    );
  }
  if (item.amazonComingSoon) {
    return (
      <span
        className="flex-1 inline-flex items-center justify-center gap-1.5 h-10 px-3 rounded-xl border-2 border-dashed border-slate-400 bg-slate-50 font-nunito font-bold text-xs sm:text-sm text-[#596882] cursor-default"
        aria-disabled="true"
        data-testid={`sdt-amazon-soon-${item.id}`}
      >
        <Clock size={16} weight="bold" /> Amazon Edition Coming Soon
      </span>
    );
  }
  return null;
};

export const ShowDontTell = () => (
  <section id="show-dont-tell" className="py-14 sm:py-20 px-4 scroll-mt-32" aria-labelledby="sdt-title">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div className="max-w-2xl">
          <span className="font-nunito font-bold text-xs uppercase tracking-[0.2em] text-[#ff8518] inline-block">Featured collection</span>
          <h2 id="sdt-title" className="font-nunito font-extrabold tracking-tight text-3xl sm:text-4xl text-[#17284b] mt-1">
            Show, Don't Tell Writing Collection
          </h2>
          <p className="font-nunito text-base sm:text-lg text-[#596882] mt-3">
            Structured writing practice for grades 2–3 that moves students from "She was happy" to vivid sentences built
            from actions, dialogue, sensory details, and reactions. Real worksheet pages — no illustrations, just clear,
            supported practice.
          </p>
        </div>
        <a href={TPT_SHOW_DONT_TELL_URL} target="_blank" rel="noopener noreferrer" data-testid="sdt-view-all-btn">
          <Button variant="outline" className="bg-white text-[#17284b] font-nunito font-bold border border-[#d4dff0] rounded-full">
            View collection on TpT <ArrowSquareOut size={16} weight="bold" className="ml-2" />
          </Button>
        </a>
      </div>

      <div className="grid md:grid-cols-2 gap-6" data-testid="sdt-grid">
        {SHOW_DONT_TELL.map((item) => (
          <article
            key={item.id}
            className={`bg-white border border-[#d4dff0] rounded-3xl overflow-hidden flex flex-col ${item.bundle ? "md:col-span-2 lg:col-span-1" : ""}`}
            data-testid={`sdt-card-${item.id}`}
          >
            <div className="grid grid-cols-5 gap-2 p-4 bg-slate-50 border-b border-[#d4dff0]">
              <img
                src={item.cover}
                alt={`${item.title} worksheet cover preview`}
                className="col-span-3 w-full aspect-[4/3] object-contain bg-white border border-[#d4dff0] rounded-xl"
                loading="lazy"
              />
              <img
                src={item.inside}
                alt={`${item.title} inside pages preview showing directions, examples, and practice`}
                className="col-span-2 w-full aspect-[4/3] object-cover object-top bg-white border border-[#d4dff0] rounded-xl"
                loading="lazy"
              />
            </div>
            <div className="p-6 flex flex-col gap-3 flex-1">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-nunito font-extrabold tracking-tight text-xl text-[#17284b] leading-tight">{item.title}</h3>
                  <p className="font-nunito text-xs sm:text-sm text-slate-500 mt-1">{item.subtitle}</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="font-nunito font-extrabold tracking-tight text-xl text-[#178478]">{item.price}</p>
                  {item.originalPrice && <p className="font-nunito text-xs text-slate-400 line-through">{item.originalPrice}</p>}
                </div>
              </div>
              <p className="font-nunito text-sm sm:text-base text-[#3f4d66] leading-relaxed">{item.blurb}</p>
              <ul className="grid grid-cols-2 gap-x-3 gap-y-1 font-nunito text-xs sm:text-sm text-[#3f4d66]">
                {item.inside_list.map((t) => (
                  <li key={t} className="flex items-start gap-1.5"><span className="text-[#178478] font-bold">✓</span>{t}</li>
                ))}
              </ul>
              <div className="flex flex-col sm:flex-row gap-2 mt-auto pt-2">
                <a href={item.tpt} target="_blank" rel="noopener noreferrer" data-testid={`sdt-tpt-${item.id}`} className="flex-1">
                  <Button className="w-full bg-[#0f285f] hover:bg-[#15367a] text-white font-nunito font-bold border border-[#d4dff0] rounded-xl">
                    TpT Digital Printable
                  </Button>
                </a>
                <AmazonButton item={item} />
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
